import PropTypes from 'prop-types';

const WaitingAnimation = ({ customer = false }) => (
  <div role="status" aria-label={customer ? 'Processing your voice' : 'Waiting for AI response'}
    style={{ position: 'fixed', bottom: '40px', ...(customer ? { right: '45px', transform: 'translateX(50%)' } : { left: '45px', transform: 'translateX(-50%)' }), pointerEvents: 'none' }}>
    <img style={{ width: '100px' }} src={require('../../static/img/animation/Animation.gif')} alt="" />
  </div>
);
WaitingAnimation.propTypes = { customer: PropTypes.bool };
export default WaitingAnimation;
